export default "__VITE_ASSET__BQVmRxnn__"